export const ASSET_STATUS = {
  CREATED: {
    label: 'Created',
    value: 'created',
    action: 'Created'
  },
  RESUBMIT: {
    label: 'Resubmit',
    value: 'resubmit',
    action: 'Resubmit'
  },
  CANCELLED: {
    label: 'Cancelled',
    value: 'cancelled',
    action: 'Cancel'
  },
  REQUESTED: {
    label: 'Requested',
    value: 'requested',
    action: 'Requested'
  },
  APPROVED: {
    label: 'Approved',
    value: 'approved',
    action: 'Approve'
  },
  REVIEW: {
    label: 'Review',
    value: 'review',
    action: 'Review'
  },
  APPROVED_FOR_DAM: {
    label: 'Approved for DAM',
    value: 'approved_for_dam',
    action: 'Approve for DAM'
  },
  PENDING: {
    label: 'Pending',
    value: 'pending',
    action: 'Pending'
  },
  IN_WORK: {
    label: 'In Work',
    value: 'in_work',
    action: 'In Work'
  }
}

export const ASSET_STATUSES_ORDER = [
  ASSET_STATUS.CREATED.value,
  ASSET_STATUS.REQUESTED.value,
  ASSET_STATUS.IN_WORK.value,
  ASSET_STATUS.REVIEW.value,
  ASSET_STATUS.PENDING.value,
  ASSET_STATUS.RESUBMIT.value,
  ASSET_STATUS.APPROVED.value,
  ASSET_STATUS.APPROVED_FOR_DAM.value,
  ASSET_STATUS.CANCELLED.value
]

export const REASONS_FOR_CANCELLATION = [
  {
    id: 1,
    name: 'After Proto HO'
  },
  {
    id: 2,
    name: 'After System Freeze'
  },
  {
    id: 3,
    name: 'After Sales'
  },
  {
    id: 4,
    name: 'During Sales'
  },
  {
    id: 5,
    name: 'DCR'
  },
  {
    id: 6,
    name: 'Proto Review'
  },
  {
    id: 7,
    name: 'During Sales Prep'
  },
  {
    id: 8,
    name: 'Sketch Review'
  },
  {
    id: 9,
    name: 'User Input Error'
  }
]

export const REASONS_FOR_RESUBMITTING = [
  { id: 1, name: 'Simulation is not correct' },
  { id: 2, name: 'Naming of file is incorrect' },
  { id: 3, name: 'Incorrect naming file or color code' },
  { id: 4, name: 'Missing colorway/s' },
  { id: 5, name: 'Incorrect fabric and/or trims' },
  { id: 6, name: 'Image size does not meet requirements' },
  { id: 7, name: 'Incorrect artwork' },
  { id: 8, name: 'Missing artwork' },
  { id: 9, name: 'Multiple reasons, check comments' },
  { id: 10, name: 'Other' }
]

export const CRITICAL_STATUSES = [
  ASSET_STATUS.RESUBMIT.value,
  ASSET_STATUS.CANCELLED.value,
  ASSET_STATUS.APPROVED_FOR_DAM.value,
  ASSET_STATUS.APPROVED.value
]

export const CRITICAL_STATUSES_NO_VALIDATION = [
  ASSET_STATUS.APPROVED_FOR_DAM.value,
  ASSET_STATUS.APPROVED.value
]
